import { InertiaLink } from "@inertiajs/inertia-react";
import React from "react";

/**
 * NavigationButtons component that renders previous and next navigation buttons
 * Supports both Inertia.js links and API callback functions for navigation
 *
 * @param {Object} props - Component props
 * @param {boolean} props.prevApi - Whether previous button should use API callback instead of link
 * @param {boolean} props.nextApi - Whether next button should use API callback instead of link
 * @param {string|Function} props.prevlink - Previous page URL (string) or callback function
 * @param {string|Function} props.nextlink - Next page URL (string) or callback function
 * @param {string} props.prevtext - Text to display on previous button (defaults to "Vorige")
 * @param {string} props.nexttext - Text to display on next button (defaults to "Volgende")
 */
const NavigationButtons = ({
    prevApi,
    nextApi,
    prevlink,
    nextlink,
    prevtext = "Vorige",
    nexttext = "Volgende",
}) => (
    <div className={"navigationbuttons d-flex flex-wrap flex-row"}>
        {prevlink ? (
            prevApi ? (
                <a
                    name={nexttext}
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        prevlink(); // Execute the callback function
                    }}
                    className={"navigationbutton"}
                >
                    {prevtext}
                </a>
            ) : (
                <InertiaLink
                    name={prevtext}
                    href={prevlink}
                    className={"navigationbutton"}
                >
                    {prevtext}
                </InertiaLink>
            )
        ) : (
            <></>
        )}

        {nextlink ? (
            nextApi ? (
                <a
                    name={nexttext}
                    href="#"
                    onClick={(e) => {
                        e.preventDefault();
                        nextlink(); // Execute the callback function
                    }}
                    className={"navigationbutton"}
                >
                    {nexttext}
                </a>
            ) : (
                <InertiaLink
                    name={nexttext}
                    href={nextlink}
                    className={"navigationbutton"}
                >
                    {nexttext}
                </InertiaLink>
            )
        ) : (
            <></>
        )}
    </div>
);

export default NavigationButtons;
